import { BasePortal, MainLoading } from '@ice-web-app/shared-ui';
import { Suspense, lazy } from 'react';
import { Navigate, Route, Routes } from 'react-router-dom';
import SatV1Zone from '../../satV1Zone';
import SatV2Zone from '../../satV2Zone';
import SatV3Zone from '../../satV3Zone';
import SatV4Zone from '../../satV4Zone';
import SatV5Zone from '../../satV5Zone';
import SmartZone from '../../smartZone';
import { app } from './routes';

const Home = lazy(() => import('../pages/home'));
const AccessDenied403 = lazy(() => import('../pages/access-denied-403'));
const NotFound = lazy(() => import('../pages/not-found'));

function AppRoutes() {
  return (
    <Suspense fallback={<MainLoading />}>
      <Routes>
        <Route path="*" element={<NotFound />} />

        <Route element={<BasePortal microSystem showUserRole />}>
          <Route path={app.base} element={<Home />} />
        </Route>
        <Route path={app.unauthorized} element={<AccessDenied403 />} />

        <Route path={`${app.smartZone}/*`} element={<SmartZone />} />
        <Route path={`${app.satV1Zone}/*`} element={<SatV1Zone />} />
        <Route path={`${app.satV2Zone}/*`} element={<SatV2Zone />} />
        <Route path={`${app.satV3Zone}/*`} element={<SatV3Zone />} />
        <Route path={`${app.satV4Zone}/*`} element={<SatV4Zone />} />
        <Route path={`${app.satV5Zone}/*`} element={<SatV5Zone />} />
      </Routes>
    </Suspense>
  );
}

export default AppRoutes;
